module.exports = __webpack_public_path__ + "img/精致美型--精准微整形.fe6d78e7.png";